import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'
import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  onOk: () => void
  onRequestClose: () => void
}

export const DeletePlayerConfirmModal = ({
  isOpen,
  onOk,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      {...rest}
      onRequestClose={onRequestClose}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        本当に削除しますか？
      </h3>

      <p className="text-center text-[15px] font-medium tracking-widest text-secondary-text">
        削除すると、学習履歴などこのプレイヤーの情報が
      </p>
      <p className="text-center text-[15px] font-medium tracking-widest text-secondary-text">
        完全に削除されます。
      </p>

      <div className="mt-[40px] flex justify-center text-[#D7DDF3]">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <Button
        className="mx-auto mt-[40px] block w-[270px]"
        variant="secondary"
        onClick={onOk}
      >
        削除する
      </Button>
    </Modal>
  )
}
